import Reflux from 'reflux';

// eslint-disable-next-line no-unused-vars
let async = { asyncResult: true },
  CuesheetResponsiveActions = Reflux.createActions({
    showCueDetail: {},
    hideCueDetail: {},
    showRowMenuModalFor: {},
    hideRowMenuModal: {},
    showDurationModalFor: {},
    hideDurationModal: {},
    showStartTimeModalFor: {},
    hideStartTimeModal: {},
    showPresetDurationModalFor: {},
    hidePresetDurationModal: {},
    updateModalField: {},
    clearModalFields: {},
    scrollTableViewHorizontally: { sync: true },
    showColumnConfigModal: {},
    hideColumnConfigModal: {},
  });

export default CuesheetResponsiveActions;
